import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({
    children,
    adminOnly = false,
    allowedRoles = null,
    skipOnboarding = false,
}) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-shariti-deep-black">
                <div className="w-10 h-10 rounded-full border-4 border-shariti-orange border-t-transparent animate-spin" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // iter-23: candidates (cooptation invitees) are gated to a waiting room until
    // an admin/manager approves them. They cannot reach any training content.
    if (user.role === "candidate" && location.pathname !== "/candidate-waiting") {
        return <Navigate to="/candidate-waiting" replace />;
    }
    if (user.role !== "candidate" && location.pathname === "/candidate-waiting") {
        return <Navigate to="/dashboard" replace />;
    }

    // Iter-27.64 — Comptes "association" : redirigés vers /asso-admin uniquement.
    // Ils n'ont accès qu'à leur propre backoffice partenaire (et au login/logout).
    // Iter-27.77 — Exception : l'asso peut visiter SA propre page partenaire
    // (`/espace-partenaires/{son_aid}`) en mode aperçu pour voir ce que voient
    // ses ambassadeurs.
    if (user.role === "association") {
        const ownAid = user.association_id;
        const onOwnPreview =
            ownAid &&
            location.pathname === `/espace-partenaires/${ownAid}`;
        const onAdmin = location.pathname.startsWith("/asso-admin");
        if (!onAdmin && !onOwnPreview) {
            return <Navigate to="/asso-admin" replace />;
        }
    }
    if (
        user.role !== "association" &&
        location.pathname.startsWith("/asso-admin")
    ) {
        return <Navigate to="/dashboard" replace />;
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    // Force learners through onboarding before accessing the rest of the app.
    // Allow the module page during onboarding (so they can complete the pitch module).
    const moduleDuringOnboarding =
        location.pathname.startsWith("/module/") &&
        location.search.includes("onboarding=1");
    if (
        !skipOnboarding &&
        (user.role === "learner" || user.role === "manager") &&
        user.onboarding_completed === false &&
        location.pathname !== "/onboarding" &&
        !moduleDuringOnboarding
    ) {
        return <Navigate to="/onboarding" replace />;
    }

    return children;
}
